
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function InputWithIcon({
    label,
    icon,
    placeholder,
    onChange,
    onKeyPress,
    value,
    type = "text",
    h,
    width = "100%",
    marginBlock = "0px",
    iconColor = "gray",
    marginInline = "auto",
}) {
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const inputType = type === "password" && isPasswordVisible ? "text" : type;

    return (
        <div style={{ width, marginBlock, marginInline }}>
            {label && (
                <label className="block mb-2 text-sm font-medium text-black font-Vazir-400">
                    {label}
                </label>
            )}

            <div
                className={`border flex align-middle rounded-[10px] items-center py-[5px] px-[10px] bg-white ${
                    h === "27" ? "h-[27px]" : "h-[40px]"
                } border-[#EBEFF3]`}
            >
                {icon && (
                    <span className="ml-2" style={{ color: iconColor }}>
                        {icon}
                    </span>
                )}

                <input
                    type={inputType}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    className="border-none outline-none font-Vazir-400 text-[10px] w-full"
                />

                {type === "password" && (
                    <span
                        className="cursor-pointer ml-2"
                        onClick={() => setPasswordVisible(!isPasswordVisible)}
                        style={{ color: iconColor }}
                    >
                        {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                    </span>
                )}
            </div>
        </div>
    );
};
